import { cn } from "@theprelude/core";
import { useExceptedFilters } from "@/queries/control-monitor";

export const ExceptionCount = ({ count }: { count: number }) => {
  const { showExcepted } = useExceptedFilters();

  if (count === 0) {
    return null;
  }

  return (
    <div
      className={cn(
        "inline-flex items-center justify-center rounded-full bg-tertiary-background px-2 py-0 text-[0.625rem] text-white font-normal",
        showExcepted && "bg-secondary-foreground",
      )}
    >
      {(showExcepted ? 0 : count).toLocaleString()}
    </div>
  );
};
